import React from 'react'

function CookiePolicy() {
  return (
    <div>CookiePolicy Coming Soon</div>
  )
}

export default CookiePolicy